<template>
  <v-container
    id="devices-list"
    tag="section"
    fluid
  >
    <v-overlay class="waitoverlay" :value="busy">
     <v-progress-circular
      indeterminate
      size="64"
      class="mr-4"
    /> {{ $t('global.loading') }}
    </v-overlay>
    <v-card>
      <v-card-title>
        {{ $t('devices.title') }} <v-spacer />
        <v-btn color="primary" :disabled="quotaFull || isAnonymousEnabled" @click="addDeviceDialog">
{{ $t('devices.create-access-code') }}
</v-btn>
        <v-btn color="secondary" :aria-label="$t('devices.refresh-devices')" @click="refreshDevices">
          <v-icon>mdi-refresh</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="searchBox">
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('global.search')"
            :aria-label="$t('global.text-field')+' '+$t('global.search') +' '+ $t('devices.devices')"
            single-line
            hide-details
          />
        </div>
        <v-data-table
                  v-model="selected"
                  filterable
                  :headers="headers.map((x) => { return { ...x, text: $t(x.text) } })"
                  :items="devices.devices"
                  item-key="id"
                  :loading="loading"
                  :search="search"
                  :items-per-page="rowsPerPage"
                >
          <template v-slot:item.name="{ item }">
            {{ clipString(item.name) }}
          </template>
          <template v-slot:item.actions="{ item }">
             <v-tooltip bottom>
              <template #activator="{ on }">
                <v-icon
                  class="mr-2"
                  :aria-label="$t('global.edit') + ' ' + $t('devices.deviceParam', [item.name])"
                  v-on="on"
                  @click="editItem(item)"
                >
                  mdi-pencil-outline
                </v-icon>
              </template>
              <span>{{ $t('edit') }}</span>
             </v-tooltip>
             <v-tooltip bottom>
                <template #activator="{ on }">
                  <v-icon
                    :aria-label="$t('global.delete') + ' ' + $t('devices.deviceParam', [item.name])"
                    v-on="on"
                    @click="deleteItem(item)"
                  >
                    mdi-delete-outline
                  </v-icon>
                </template>
                <span>{{ $t('delete') }}</span>
             </v-tooltip>
          </template>
          <template v-slot:item.lastSeen="{ item }">
            {{ displayTime(item.lastSeen) }}
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip v-if="!item.disabled" class="status mr-2" :class="item.config.operationMode">
{{ $t('devices.operation-mode-'+item.config.operationMode) }}
</v-chip>
            <v-chip v-if="item.disabled" class="status disabled mr-2">
{{ $t('globcal.disabled') }}
</v-chip>
          </template>
          <template v-slot:item.config.session.user="{ item }">
            {{ displayName(item.config.session.user) }}
          </template> -->
        </v-data-table>
    </v-card-text>
    </v-card>

    <v-row justify="center">
      <v-dialog
        v-model="showEditDialog"
        max-width="700px"
      >
        <device-edit
          ref="deviceedit"
          :device="editedItem"
          @cancel="closeEditDialog"
          @save="saveEditDialog"
        />
      </v-dialog>
       <v-dialog v-model="showAddDeviceDialog" max-width="500px">
         <shortcode-generator action="registerDevice" description="hi">
           {{ $t('devices.generator-code-description') }}
</shortcode-generator>
        </v-dialog>
        <v-dialog v-model="showDeleteDialog" max-width="500px">
          <v-card>
            <v-card-title>{{ $t('global.confirm') }}</v-card-title>
            <v-card-text>{{ $t('devices.delete-confirm-text') }} <span class="font-weight-bold">{{ selectedDeviceName }}</span>?</v-card-text>
            <v-card-actions>
              <v-spacer />
              <v-btn color="blue" @click="closeDeleteDialog">
{{ $t('global.no') }}
</v-btn>
              <v-btn color="red" @click="confirmDeleteItem">
{{ $t('global.yes') }}
</v-btn>
              <v-spacer />
            </v-card-actions>
          </v-card>
        </v-dialog>
    </v-row>
  </v-container>
</template>

<script>
  import api from '@/helpers/api.js'
  import moment from 'moment'
  import deviceEdit from './DeviceEdit.vue'
  import { Users } from '@/helpers/users.js'
  import shortcodeGenerator from './ShortcodeGenerator.vue'

  export default {
    name: 'Devices',

    components: {
      'device-edit': deviceEdit,
      'shortcode-generator': shortcodeGenerator,
    },

    data () {
      return {
        accountName: 'Account 1',
        code: '------',
        devices: {
          maxDevices: 0,
          devices: [],
        },
        expiryTime: null,
        editedIndex: -1,
        editedItem: {},
        headers: [
          { text: 'devices.header.identifier', align: 'start', sortable: true, value: 'name' },
          { text: 'devices.header.platform', value: 'type' },
          { text: 'devices.header.last-seen', value: 'lastSeen' },
          { text: 'devices.header.operational-mode', value: 'status' },
          { text: 'devices.header.assigned-learner', value: 'config.session.user' },
          { text: 'devices.header.actions', value: 'actions', sortable: false },
        ],
        rowsPerPage: 15,
        interval: null,
        loading: true,
        showEditDialog: false,
        showDeleteDialog: false,
        selected: [],
        search: '',
        showAddDeviceDialog: false,
        timeRemaining: '',
        busy: false,
      }
    },

    computed: {
      selectedDeviceName () {
        return this.editedItem.name
      },

      quotaFull () {
        return (this.devices.devices.length >= this.devices.maxDevices) && this.devices.maxDevices > 0
      },

      title () {
        if (!this.$store.state.user) {
          return this.$t('devices.devices')
        }

        if (this.devices.maxDevices === 0) {
          return `${this.$store.getters.currentUserProfile.account.displayName} ${this.$t('devices.devices')} (${this.devices.devices.length})`
        } else {
          return `${this.$store.getters.currentUserProfile.account.displayName} ${this.$t('devices.devices')} (${this.devices.devices.length} / ${this.devices.maxDevices})`
        }
      },

      isAnonymousEnabled () {
        return this.$store.getters.currentUserProfile.account.maxUsers !== 0
      },
    },

    async mounted () {
      this.refreshDevices()
    },

    methods: {
      formatCode (code) {
        return '<div>' + code + '</div>'
      },

      displayName (id) {
        return Users.GetDisplayName(id)
      },

      clipString (str) {
        const length = window.innerWidth < 600 ? 16 : 32
        if (str.length > length) {
          return str.substr(0, length) + '...'
        }
        else {
          return str
        }
      },
      async refreshDevices () {
        this.loading = true
        this.devices = await api.getDevices()
        for (let i = 0; i < this.devices.devices.length; i++)
        {
          if (!this.devices.devices[i].config.session) {
            this.devices.devices[i].config.session = { user: null }
          }
        }
        this.loading = false
      },

      /* async generateShortcode () {
        const payload = await api.inviteDevice()
        this.code = payload.shortCode
        this.expiryTime = payload.expires
        // console.log(`shortcode returned ${payload}`)
      }, */

      addDeviceDialog () {
        this.showAddDeviceDialog = true
        // this.generateShortcode()
      },

      hideAddDeviceDialog () {
        this.showAddDeviceDialog = false
        this.refreshDevices()
      },

      displayTime (time) {
        return moment(time).format('HH:mm DD/MM/YY')
      },

      async editItem (item) {
        // console.log(`edit item ${item.id}`)
        this.editedIndex = this.devices.devices.indexOf(item)
        Object.assign(this.editedItem, this.devices.devices[this.editedIndex])
        this.showEditDialog = true
        this.$nextTick(() => {
          this.$refs.deviceedit.setup()
        })
      },
      closeEditDialog () {
        this.showEditDialog = false
      },
      async saveEditDialog () {
        // console.log(JSON.stringify(this.editedItem))
        this.showEditDialog = false
        Object.assign(this.devices.devices[this.editedIndex], this.editedItem)
        this.refreshDevices()
      },
      async confirmDeleteItem () {
        this.closeDeleteDialog()
        this.devices.devices.splice(this.editedIndex, 1)
        this.busy = true
        await api.deleteDevice(this.editedItem.id)
        this.busy = false
      },
      deleteItem (item) {
        this.editedItem = item
        this.editedIndex = this.devices.devices.indexOf(item)
        this.showDeleteDialog = true
      },
      closeDeleteDialog () {
        this.showDeleteDialog = false
      },
    },
  }
</script>

<style scoped>
  .disabled { background-color: #ccc4c4 !important; color: black; }
  .normal { background-color: #73963c !important; color: black; }
  .demo { background-color: steelblue !important; color: black; }
  .userkiosk { background-color: #ff3f3f !important; color: black; }
  .quotaWarning { color: red }
</style>
